import React from 'react';
import loadingGIF from '../../assets/images/loading.gif';
import '../../scss/style/loading.scss';

const Loading = () => {
  return (
    <div className="loading">
      <img className='loading-image' src={loadingGIF} alt='loading' />
      {/* <p>Loading</p> */}
    </div>
  );
};

export default Loading;
